// AUTOGENERATED - MANUALLY CHANGES WILL BE REVERTED BY THE GENERATOR
// IPoolAddressesProvider https://soneium.blockscout.com/address/0x82405D1a189bd6cE4667809C35B37fBE136A4c5B
export const POOL_ADDRESSES_PROVIDER = '0x82405D1a189bd6cE4667809C35B37fBE136A4c5B';

// IPool https://soneium.blockscout.com/address/0xDd3d7A7d03D9fD9ef45f3E587287922eF65CA38B
export const POOL = '0xDd3d7A7d03D9fD9ef45f3E587287922eF65CA38B';

// IPoolConfigurator https://soneium.blockscout.com/address/0x1607FCeEc8dEbA4d5Da66D620b2363066d025a02
export const POOL_CONFIGURATOR = '0x1607FCeEc8dEbA4d5Da66D620b2363066d025a02';

// IAaveOracle https://soneium.blockscout.com/address/0x20040a64612555042335926d72B4E5F667a67fA1
export const ORACLE = '0x20040a64612555042335926d72B4E5F667a67fA1';

// https://soneium.blockscout.com/address/0xc0Bac16A64FbAa7EE6483bD12a759e28cD13dcBe
export const PRICE_ORACLE_SENTINEL = '0xc0Bac16A64FbAa7EE6483bD12a759e28cD13dcBe';

// https://soneium.blockscout.com/address/0x47aAdaAE1F05C978E6aBb7568d11B7F6e0FC4d6A
export const ACL_ADMIN = '0x47aAdaAE1F05C978E6aBb7568d11B7F6e0FC4d6A';

// IACLManager https://soneium.blockscout.com/address/0x7635bFF69E52023aB76267ab1EFf63434cdCe458
export const ACL_MANAGER = '0x7635bFF69E52023aB76267ab1EFf63434cdCe458';

// IPoolDataProvider https://soneium.blockscout.com/address/0x4a24b44b252db149B5B9BCec4dc3c2752807d626
export const AAVE_PROTOCOL_DATA_PROVIDER = '0x4a24b44b252db149B5B9BCec4dc3c2752807d626';

// https://soneium.blockscout.com/address/0xf2225A9099Ac572b65214Cb63Cd9482370B1f9F6
export const POOL_IMPL = '0xf2225A9099Ac572b65214Cb63Cd9482370B1f9F6';

// https://soneium.blockscout.com/address/0x6fDdde45f777a4E461B0721a578b169b44579623
export const POOL_CONFIGURATOR_IMPL = '0x6fDdde45f777a4E461B0721a578b169b44579623';

// https://soneium.blockscout.com/address/0xE9Dfe1cbD5F10C56c1466F6AC88e1Fb304Be3780
export const DEFAULT_INCENTIVES_CONTROLLER = '0xE9Dfe1cbD5F10C56c1466F6AC88e1Fb304Be3780';

// https://soneium.blockscout.com/address/0x2026b787C82331c364EAc13bf761Ca75eDeb0A4B
export const EMISSION_MANAGER = '0x2026b787C82331c364EAc13bf761Ca75eDeb0A4B';

// ICollector https://soneium.blockscout.com/address/0xc7B3cc5F5988613b0D620623C514EDFB32539720
export const COLLECTOR = '0xc7B3cc5F5988613b0D620623C514EDFB32539720';

// https://soneium.blockscout.com/address/0x102EaA833530Eb822611adc19A9b9dc029eb570d
export const DEFAULT_A_TOKEN_IMPL = '0x102EaA833530Eb822611adc19A9b9dc029eb570d';

// https://soneium.blockscout.com/address/0xdaE4c42F6d70a53D8b3689535556615C0483538a
export const DEFAULT_VARIABLE_DEBT_TOKEN_IMPL = '0xdaE4c42F6d70a53D8b3689535556615C0483538a';

// https://soneium.blockscout.com/address/0x7CB7fdeEB5E71f322F8E39Be67959C32a6A3aAA3
export const CONFIG_ENGINE = '0x7CB7fdeEB5E71f322F8E39Be67959C32a6A3aAA3';

// https://soneium.blockscout.com/address/0xD9145b5F45Ad4519c7ACcD6E0A4A82e83bB8A6Dc
export const RISK_STEWARD = '0xD9145b5F45Ad4519c7ACcD6E0A4A82e83bB8A6Dc';

// https://soneium.blockscout.com/address/0x629A5a607aC4901252e4C48a0Fde156785598F5b
export const POOL_ADDRESSES_PROVIDER_REGISTRY = '0x629A5a607aC4901252e4C48a0Fde156785598F5b';

// https://soneium.blockscout.com/address/0xCB5B3ca20603231945dC5731C33E7f7F7679Ea89
export const UI_INCENTIVE_DATA_PROVIDER = '0xCB5B3ca20603231945dC5731C33E7f7F7679Ea89';

// https://soneium.blockscout.com/address/0xc69299Ddd3a704F6954c8Ae1AD00e0892d77Aee4
export const UI_POOL_DATA_PROVIDER = '0xc69299Ddd3a704F6954c8Ae1AD00e0892d77Aee4';

// https://soneium.blockscout.com/address/0xF4c6Af5A37c284d907c668EbF76FbD7C139d4c11
export const WALLET_BALANCE_PROVIDER = '0xF4c6Af5A37c284d907c668EbF76FbD7C139d4c11';

// https://soneium.blockscout.com/address/0x6376D4df995f32f308f2d5049a7a320943023232
export const WETH_GATEWAY = '0x6376D4df995f32f308f2d5049a7a320943023232';

// https://soneium.blockscout.com/address/0x535b2f7C20B9C83d70e519cf9991578eF9816B7B
export const STATA_FACTORY = '0x535b2f7C20B9C83d70e519cf9991578eF9816B7B';

// https://soneium.blockscout.com/address/0x03001Bcf6C6B916E793f7BB49b8928c29882b3D8
export const DUST_BIN = '0x03001Bcf6C6B916E793f7BB49b8928c29882b3D8';

export const CHAIN_ID = 1868;
export const ASSETS = {
  WETH: {
    decimals: 18,
    id: 0,
    UNDERLYING: '0x4200000000000000000000000000000000000006',
    A_TOKEN: '0x1bD45Cc20CE61BE344A64218E6Ade01E72b08f39',
    V_TOKEN: '0xC52375A5A04C0ABe5a6Ca5F3a344be2415EF54dB',
    INTEREST_RATE_STRATEGY: '0x486C2D3F59E4d72f3cAa301a7eF19E3db657F5b0',
    ORACLE: '0x291cF980BA12505D65ee01BDe0882F1d5e533525',
  },
  USDCe: {
    decimals: 6,
    id: 1,
    UNDERLYING: '0xbA9986D2381edf1DA03B0B9c1f8b00dc4AacC369',
    A_TOKEN: '0xb2C9E934A55B58D20496A5019F8722a96d8A44d8',
    V_TOKEN: '0xccE2594ea5bC482DB9b4826Ce25d0764fE56BfD8',
    INTEREST_RATE_STRATEGY: '0x486C2D3F59E4d72f3cAa301a7eF19E3db657F5b0',
    ORACLE: '0xe9d6696fc74A8ef545D2c9C842f820763407E778',
  },
  USDT: {
    decimals: 6,
    id: 2,
    UNDERLYING: '0x3A337a6adA9d885b6Ad95ec48F9b75f197b5AE35',
    A_TOKEN: '0xBAB0366ADdA6d2845c6BB5db4339A824350d24F7',
    V_TOKEN: '0xb3B6f42Ef71DDd9348136FFBdF02B545c0d2B799',
    INTEREST_RATE_STRATEGY: '0x486C2D3F59E4d72f3cAa301a7eF19E3db657F5b0',
    ORACLE: '0x01bcEb741614D4388028EaF3284DCB04386c30D2',
  },
} as const;
export const E_MODES = {} as const;
export const EXTERNAL_LIBRARIES = {
  FLASHLOAN_LOGIC: '0xE66AdcF153d0bD67a74e5d23e23F90b4011024EC',
  BORROW_LOGIC: '0x1Fb8f7C906cddD28B42ae6Eb76abC04A91188635',
  LIQUIDATION_LOGIC: '0x8dc095F287dBEBD9e15f75BB3DfBF18389BB8104',
  POOL_LOGIC: '0x25Ed699a052B820d772765E26Ed4dD9f0A26F3E5',
  SUPPLY_LOGIC: '0x33654b16A4De97bCE05d7dD06803Bf1066f3123C',
} as const;
